const farmageo_api = process.env.REACT_APP_FARMAGEO_API;
const image_path_server = process.env.REACT_APP_FARMAGEO_BUCKET;
const google_api = process.env.REACT_APP_GOOGLE_API;

const frontendEntornoFun = () => {
  if (process.env.REACT_APP_LOCAL_DEV === "true") {
    const STORAGE_KEY = "front_app";
    let front = localStorage.getItem(STORAGE_KEY) || "cfsf"; //cfsf, delivery, farmacias

    const panel = document.createElement("div");
    panel.style.padding = "0px";
    panel.style.background = "#eee";
    panel.style.borderBottom = "1px solid #ccc";
    panel.style.position = "relative";

    const select = document.createElement("select");

    [
      { value: "cfsf", label: "CFSF" },
      { value: "farmacias", label: "Farmacias" },
      { value: "delivery", label: "Delivery" },
    ].forEach((opt) => {
      const option = document.createElement("option");
      option.value = opt.value;
      option.textContent = opt.label;
      select.appendChild(option);
    });

    select.value = front;
    select.addEventListener("change", () => {
      front = select.value;
      localStorage.setItem(STORAGE_KEY, front);
    });

    panel.appendChild(select);

    // insertar arriba de todo
    document.body.insertBefore(panel, document.body.firstChild);

    if (front === "cfsf")
      return {
        theme: process.env.REACT_APP_THEME,
        connection: process.env.REACT_APP_HEADER_X_CONNECTION,
        origin: process.env.REACT_APP_HEADER_X_FRONTEND_ORIGIN,
        menu: process.env.REACT_APP_MENU,
      };
    if (front === "delivery")
      return {
        theme: process.env.REACT_APP_THEME_FM,
        connection: process.env.REACT_APP_HEADER_X_CONNECTION_FM,
        origin: process.env.REACT_APP_HEADER_X_FRONTEND_ORIGIN_FM,
        menu: process.env.REACT_APP_MENU_FM,
      };
    if (front === "farmacias")
      return {
        theme: "cfsf",
        connection: process.env.REACT_APP_HEADER_X_CONNECTION_F,
        origin: process.env.REACT_APP_HEADER_X_FRONTEND_ORIGIN_F,
        menu: process.env.REACT_APP_MENU_F,
      };
  } else {
    return {
      theme: process.env.REACT_APP_THEME,
      connection: process.env.REACT_APP_HEADER_X_CONNECTION,
      origin: process.env.REACT_APP_HEADER_X_FRONTEND_ORIGIN,
      menu: process.env.REACT_APP_MENU,
    };
  }
};
const frontendEntorno = frontendEntornoFun();

export {
  farmageo_api,
  image_path_server,
  google_api,
  frontendEntorno,
};
